export const fundingSourceOptions = [
  {
    id: 'GEU',
  },
  {
    id: 'U',
  },
  {
    id: 'UNRB',
  },
  {
    id: 'P',
  },
  {
    id: 'I',
  },
];
